import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useReducedMotion } from '../../../theme/hooks.js';
import type { IconProps } from '../../primitives/types.js';

const DOTS: Array<{ cx: number; cy: number }> = [
  { cx: 8, cy: 2 },
  { cx: 12.24, cy: 3.76 },
  { cx: 14, cy: 8 },
  { cx: 12.24, cy: 12.24 },
  { cx: 8, cy: 14 },
  { cx: 3.76, cy: 12.24 },
  { cx: 2, cy: 8 },
  { cx: 3.76, cy: 3.76 },
];

export function IcnSpinner(props: IconProps): ReactNode {
  const reduced = useReducedMotion();
  return (
    <Svg {...props} iconName="spinner" stroke="none">
      {DOTS.map((d, i) => (
        <circle
          key={i}
          cx={d.cx}
          cy={d.cy}
          r="1.1"
          fill="currentColor"
          opacity={reduced ? 0.55 : 0.15}
        >
          {!reduced && (
            <animate
              attributeName="opacity"
              values="0.15;1;0.15"
              dur="1.2s"
              begin={`${(i * 0.15).toFixed(2)}s`}
              repeatCount="indefinite"
            />
          )}
        </circle>
      ))}
    </Svg>
  );
}
